import { subscribe } from 'satcheljs/lib/legacy/stitch';
import { lazyApplyConversationFlagInReadingPane } from 'owa-mail-reading-pane-store';
import { ApplyConversationFlagStateStoreUpdateActionName, } from 'owa-mail-store-actions';
export default function subscribeToApplyConversationFlaggedStateStitch() {
    subscribe(ApplyConversationFlagStateStoreUpdateActionName, function (conversationIds, flagType, tableViewId) {
        lazyApplyConversationFlagInReadingPane.importAndExecute(conversationIds, flagType, tableViewId);
    });
}
//# sourceMappingURL=applyConversationFlaggedStateStitch.js.map